import { render, staticRenderFns } from "./IdcCreateEditContactPointOrSale.vue?vue&type=template&id=acddfc7e&scoped=true&"
import script from "./IdcCreateEditContactPointOrSale.vue?vue&type=script&lang=js&"
export * from "./IdcCreateEditContactPointOrSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acddfc7e",
  null
  
)

export default component.exports